export default __webpack_public_path__ + "static/media/plugPositive.688110d4.svg";